import React from "react";
import { useHistory } from "react-router-dom";
import { Form, Formik } from "formik";

import { Typography } from "@mui/material";

import Layout from "@components/Layout";
import ROUTES from "@config/routes";

import UserForm from "../shared/ui/UserForm";
import { INITIAL_VALUES } from "./interface";
import { useSubmitAddUser } from "./useSubmitAddUser";
import FormAddUserValidationSchema from "./validation";

const AddUserPage: React.FC = () => {
  const history = useHistory();
  const { loading, handleSubmit } = useSubmitAddUser();

  return (
    <Layout disableToolbar disableToolbarMobile>
      <Typography
        sx={{
          color: "#3E3D3D",
          fontWeight: "bold",
          fontSize: { xs: "2rem", sm: "2.5rem" },
          pt: "20px",
          pl: { xs: "1.5rem", sm: "5rem" },
        }}
      >
        Cadastrar novo usuário
      </Typography>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={FormAddUserValidationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <UserForm
            loading={loading}
            title="Dados do novo usuário"
            submitLabel="Finalizar"
            submitLoadingLabel="Finalizando..."
            onCancel={() => history.push(ROUTES.ADMIN_ROUTES.HOME)}
          />
        </Form>
      </Formik>
    </Layout>
  );
};

export default AddUserPage;
